import {
    Component,OnInit
  } from '@angular/core';
  import { Router } from '@angular/router';

  import {
    AccountService
  } from '../../../../_services';
  @Component({
    selector: 'right-box',
    templateUrl: 'right-box.component.html',
    styleUrls:['../../../../../assets/css/common.css']
  })
  export class RightBoxComponent implements OnInit{

    currentUrl:any;
    constructor(private accountService: AccountService,private router:Router) {

       this.currentUrl = this.router.url;

   

    }
    ngOnInit(){

    }

     
    
  }